import { CommonModule, NgIf } from "@angular/common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PaymentService } from "../../../../../../mijn/src/app/activity/services/payment.service";
import { Payment } from "../../../../../../mijn/src/app/member/models/payment";
import { ModalComponent } from "../../../_shared/components/layout/modal/modal.component";
import { BasePage } from "../../../_shared/components/layout/pages/base-page";
import { ButtonComponent } from "../../../_shared/form/components/button/button.component";
import { HorizontalTextInputComponent } from "../../../_shared/form/components/horizontal-text-input/horizontal-text-input.component";
import { HorizontalWrapperComponent } from "../../../_shared/form/components/horizontal-wrapper/horizontal-wrapper.component";
import { SelectComponent } from "../../../_shared/form/components/select/select.component";
import { AddressBaseEditComponent } from "../../../address/components/address-base-edit/address-base-edit.component";
import { AddressFormModel } from "../../../address/form-models/address-form-model";
import { Address } from "../../../address/models/address";
import { OrderDto } from "../../../orders/models/order";
import { OrderService } from "../../../orders/services/order.service";
import { FederationBasicDto } from "../../../organisation/models/federation";
import { SubscriptionDto } from "../../../organisation/models/subscription";
import { OrganizationService } from "../../../organisation/services/organization.service";
import { SubscriptionService } from "../../../organisation/services/subscription.service";

@Component({
  selector: "app-subscription-renew-modal",
  templateUrl: "./subscription-renew-modal.component.html",
  styleUrls: ["./subscription-renew-modal.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    ReactiveFormsModule,
    AddressBaseEditComponent,
    ButtonComponent,
    HorizontalWrapperComponent,
    HorizontalTextInputComponent,
    SelectComponent,
    ModalComponent,
  ],
})
export class SubscriptionRenewModalComponent extends BasePage implements OnInit, OnDestroy {
  @Input() paymentKey: string = "";

  facturationAddress = new AddressFormModel({} as Address);
  currentSubscription: SubscriptionDto = {} as SubscriptionDto;
  federation: FederationBasicDto | null = null;
  startOrder: OrderDto | null = null;
  plusOrder: OrderDto | null = null;
  orderToRenew: OrderDto | null = null;
  payment: Payment | null = null;
  today = new Date();
  nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1) - 86400000); //volgend jaar - 1 dag
  step = 1;

  constructor(
    protected override route: ActivatedRoute,
    modal: NgbModal,
    public activeModal: NgbActiveModal,
    private subscriptionService: SubscriptionService,
    private organizationService: OrganizationService,
    private orderService: OrderService,
    private paymentService: PaymentService
  ) {
    super(route, modal);
  }

  ngOnInit(): void {
    if (this.paymentKey) {
      this.paymentService.check(this.paymentKey).subscribe((x) => {
        this.isLoading = false;
        this.payment = x;
        this.step = 3;
      });
    } else {
      this.loadSubscription();
    }
  }

  ngOnDestroy(): void {}

  loadSubscription(): void {
    this.subscriptionService.getCurrent().subscribe((data) => {
      this.currentSubscription = data;
      this.currentSubscription.FacturationAddress =
        this.currentSubscription.FacturationAddress || {};

      this.facturationAddress = new AddressFormModel(this.currentSubscription.FacturationAddress);

      this.organizationService.getCurrentFederation().subscribe((data) => {
        this.federation = data;

        if (this.shouldRenewOrOrder()) {
          this.processRenewSubscription(4);
          this.processRenewSubscription(1);
        } else {
          this.processRenewSubscription(1);
        }
      });
    });
  }

  private shouldRenewOrOrder(): boolean {
    return (
      this.federation != null &&
      (this.federation.FreeStartSubscription ||
        this.currentSubscription.SubscriptionStatus.Abbreviation === "PRF" ||
        this.currentSubscription.SubscriptionType.Id > 1 ||
        this.federation.CanOrderStartSubscription === true)
    );
  }

  private processRenewSubscription(orderType: number): void {
    this.orderService.getForRenewSubscription(orderType).subscribe((data) => {
      if (orderType == 1) this.plusOrder = data;
      if (orderType == 4) this.startOrder = data;
      this.facturationAddress = new AddressFormModel(data.Address);
      this.isLoading = false;
    });
  }

  payRenewal(order: OrderDto | null): void {
    if (order) {
      this.isLoading = true;
      order.UrlAfterPayment = this.getRedirectUrl();
      order.Address = this.facturationAddress.mapToModel() as Address;

      this.orderService.pay(order).subscribe((url: string) => {
        window.location.href = url; // Direct redirection to the payment URL
      });
    }
  }

  next(order: OrderDto | null) {
    this.step++;
    this.orderToRenew = order;
  }
  back() {
    this.step--;
  }
  getRedirectUrl(): string {
    const url = window.location.href;
    return url.includes("?") ? url + "&paymentKey=" : url + "?paymentKey=";
  }
}
